<section class="team-directory">
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="directory-panel">
    <div class="panel-header">
      <div>
        <h1>Чемпионаты</h1>
        <span *ngIf="loading">Обновляем данные...</span>
        <span *ngIf="!loading">{{ championships.length }} чемпионатов</span>
      </div>
      <a class="action-button primary" routerLink="/dashboard/championship/new">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
        <span>Добавить чемпионат</span>
      </a>
    </div>

    <div class="teams-table-wrap" *ngIf="championships.length > 0; else emptyChampionships">
      <table class="teams-table">
        <thead>
          <tr>
            <th><button type="button" (click)="toggleSort()" [attr.aria-sort]="sortDirection === 'asc' ? 'ascending' : 'descending'">Чемпионат</button></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let championship of sortedChampionships; trackBy: trackById" [routerLink]="['/dashboard/championship', championship.slug || championship.id]">
            <td>
              <div class="team-cell">
                <span class="team-logo" [style.background-image]="getLogoBackground(championship)">{{ championship.logoUrl ? '' : championship.name.charAt(0) }}</span>
                <strong>{{ championship.name }}</strong>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyChampionships>
      <div class="empty-state">Чемпионаты пока не добавлены.</div>
    </ng-template>
  </section>
</section>
